<template>
  <div
    class="text-center"
    :class="{ 'flex flex-row items-center': action, 'flex-row-reverse': isLeft }"
    @touchend="onClick"
    @click="onClick"
  >
    <div class="btn relative" :style="btnStyles">
      <transition-group name="fade" tag="div">
        <img
          :key="1"
          class="img-1"
          v-show="!hit"
          :class="{ breathing: shouldBreath }"
          :src="images[0]"
        />
        <img
          :key="2"
          class="img-2"
          v-show="!hit"
          :class="{ breathing: shouldBreath }"
          :src="images[1]"
        />
        <img :key="3" class="img-3" v-show="!hit" :src="images[2]" />
        <img :key="4" class="img-4" v-show="!hit" :src="images[3]" />
      </transition-group>
      <transition-group name="fill" tag="div">
        <img :key="5" class="img-5" v-show="hit" :src="images[4]" />
      </transition-group>
      <span
        v-if="action"
        class="action instruction main-gradient"
        :class="{ 'secondary-gradient': isLeft }"
        :style="actionStyles"
      >
        {{ action }}
      </span>
    </div>
  </div>
</template>

<script>
import breathing from '../../mixins/breathing';

import main1 from '../../assets/HoverButton/main-1.svg';
import main2 from '../../assets/HoverButton/main-2.svg';
import main3 from '../../assets/HoverButton/main-3.svg';
import main4 from '../../assets/HoverButton/main-4.svg';
import mainFill from '../../assets/HoverButton/main-fill.svg';
import secondary1 from '../../assets/HoverButton/secondary-1.svg';
import secondary2 from '../../assets/HoverButton/secondary-2.svg';
import secondary3 from '../../assets/HoverButton/secondary-3.svg';
import secondary4 from '../../assets/HoverButton/secondary-4.svg';
import secondaryFill from '../../assets/HoverButton/secondary-fill.svg';

const MAIN_IMAGES = [main1, main2, main3, main4, mainFill];
const SECONDARY_IMAGES = [secondary1, secondary2, secondary3, secondary4, secondaryFill];

export default {
  name: 'FillButton',
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
    hit: Boolean,
    hitDuration: {
      type: Number,
      default: 3000,
    },
    action: String,
    isLeft: Boolean,
    offset: {
      type: Number,
      default: 50,
    },
  },
  mixins: [breathing],
  mounted() {
    this.hitTimer = null;
  },
  beforeDestroy() {
    if (this.hitTimer) {
      clearTimeout(this.hitTimer);
    }
  },
  data: () => ({
    active: false,
  }),
  watch: {
    hit(nv, ov) {
      if (nv && !ov) {
        this.onHit();
      } else if (ov && !nv) {
        this.active = false;
      }
    },
  },
  methods: {
    onHit() {
      if (this.active) return;

      this.active = true;
      this.hitTimer = setTimeout(() => {
        this.$emit('active');
      }, this.hitDuration);
    },
    onClick() {
      this.active = true;
      this.$emit('click');
    },
  },
  computed: {
    btnStyles() {
      if (this.isLeft) return { right: `${this.offset}px` };

      return { left: `${this.offset}px` };
    },
    actionStyles() {
      const offset = this.mini ? '-250%' : '-85%';
      const style = {};
      if (this.mini) {
        style.transform = 'scale(3)';
      }
      if (this.isLeft) return { ...style, left: offset };

      return { ...style, right: offset };
    },
    images() {
      return this.isLeft && this.action ? SECONDARY_IMAGES : MAIN_IMAGES;
    },
  },
};
</script>

<style scoped lang="scss">
.btn > div {
  @apply relative flex mx-auto justify-center items-center;
  width: 140px;
  bottom: 20px;
  img {
    @apply absolute;
  }
}
.fade-enter-active {
  transition: all 0.5s ease-in;
}
.fade-leave-active {
  transition: all 2.5s ease-out;
}
.fade-enter-to,
.fade-leave {
  transform: scale(1) rotate(0);
}
.fade-enter,
.fade-leave-to {
  transform: scale(0) rotate(-200deg);
}

.fill-enter-active {
  transition: all 1s ease-out;
}
.fill-leave-active {
  transition: all 0.3s ease-out;
}
.fill-enter-to,
.fill-leave {
  transform: scale(1);
}
.fill-enter,
.fill-leave-to {
  transform: scale(0);
}
.instruction {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #540DEB;
}
.main-gradient {
  background-image: linear-gradient(to top, #540DEB, #2245FF);
  color: #540DEB;
}
.secondary-gradient {
  background-image: linear-gradient(to top, #656565, #131313);
  color: #656565;
}
.action {
  position: absolute;
  top: calc(50% - 15px);
  transform: translateY(-50%);
}
</style>
